import * as React from "react";

const ADD_TO_CART_PATH = "/cart/add.js";

export const addToCart = (
  variant: { id: any },
  quantity = 1,
  properties: { [key: string]: any } = {},
  onSuccess: Function,
  onError: Function,
) => {
  if (variant) {
    fetch(ADD_TO_CART_PATH, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({
        quantity: quantity,
        id: variant.id,
        properties: properties,
      }),
    })
      .then(function () {
        updateCartIcon(quantity);
        onSuccess();
      })
      .catch(function (res) {
        onError();
      });
  }
};

const updateCartIcon = (quantity: number) => {
  const event = new CustomEvent("cart-change", {
    detail: { quantity: quantity },
  });
  window.dispatchEvent(event);
};
